import InputField from "./InputField";
import { useSelector } from "react-redux";

const HALF_SPAN_XS_FIELDS = new Set([
  "firstName",
  "lastName",
  "buildingNum",
  "ApartmentNum",
  "phoneNumber",
  "areaCode",
  "company",
  "companyId",
]);

const HALF_SPAN_MD_FIELDS = new Set([
  "firstName",
  "lastName",
  "buildingNum",
  "ApartmentNum",
  "zip",
  "company",
  "companyId",
  "city",
  "street",
]);

const PersonalDetailsSection = ({ fields, data, setData, errors }) => {
  const isCollectionBucketCouponFromShipping = useSelector(
    (state) => state.coupons.isCollectionBucketCouponFromShipping
  );
  const direction = useSelector((state) => state.mode.direction);
  const fieldOrderByDirection = direction === "rtl"
    ? { phoneNumber: 1, areaCode: 2 }
    : { phoneNumber: 2, areaCode: 1 };

  const getFieldOrder = (field) => fieldOrderByDirection[field];
  const sectionKey = fields?.[0]?.section || "unknown";

  const getSpanClassName = (field) => {
    const isHalfOnXs = HALF_SPAN_XS_FIELDS.has(field);
    const isHalfOnMd =
      HALF_SPAN_MD_FIELDS.has(field) ||
      (isCollectionBucketCouponFromShipping &&
        (field === "phoneNumber" || field === "areaCode"));

    return `${isHalfOnXs ? "col-span-6" : "col-span-12"} ${
      isHalfOnMd ? "md:col-span-6" : "md:col-span-3"
    }`;
  };

  return (
    <div
      className="w-full box-border px-4 lg:px-0"
      data-testid={`personal-details-section-${sectionKey}`}
    >
      <div
        className="personal-details-grid grid grid-cols-12 gap-x-4 pb-6"
        style={{ direction }}
        data-testid={`personal-details-grid-${sectionKey}`}
      >
        {fields.map(
          ({
            label,
            field,
            type,
            options,
            dependsOn,
            onChange,
            onSelect,
            maxLength,
            section,
          }) => (
            <div
              key={field}
              className={`personal-details-grid-item min-w-0 ${getSpanClassName(field)}`}
              style={{
                order: getFieldOrder(field),
              }}
              data-testid={`personal-details-field-wrapper-${field}-${section || sectionKey}`}
            >
              <InputField
                section={section}
                label={label}
                value={data[field]}
                onChange={
                  onChange ||
                  ((value) => setData((prev) => ({ ...prev, [field]: value })))
                }
                onSelect={onSelect}
                error={!!errors[field]}
                helperText={errors[field]}
                type={type}
                options={options}
                disabled={dependsOn && !data[dependsOn]}
                maxLength={maxLength || 21}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default PersonalDetailsSection;
